import html from 'text!modules/jquery.localisationSelectorTemplate.html';
import $ from 'jquery';
import 'jquery-ui/ui/unique-id';

function localisationSelector($localisationSelector, customOptions) {
  let options = {
    onInit: function(selectedItems) {},
    onItemsSelected: function(selectedItems) {},
    availableItems: {},
    selectedItems: {}
  };

  if (customOptions) {
    $.extend(options, customOptions);
  }

  $localisationSelector.html(html);
  const $fieldsetLocalisation = $('.localisation-dropdown-selector').first(),
    $suggestedCities = $localisationSelector.find('.js-city-suggested-elements'),
    $suggestedDepartments = $localisationSelector.find('.js-department-suggested-elements'),
    $suggestedRegions = $localisationSelector.find('.js-region-suggested-elements');

  let selectedItems = options.selectedItems;
  const availableItems = options.availableItems;

  const NOT_FOUND_TEXT =
    "Pas de correspondance trouv&eacute;e. V&eacute;rifiez l'orthographe ou essayez";

  renderSelector();
  options.onInit(selectedItems);

  function renderSelector() {
    $fieldsetLocalisation.uniqueId();

    const uniqueId = $fieldsetLocalisation.attr('id');
    initLocalisations(uniqueId);

    $('.js-suggestion-label').click(function() {
      const $currentSuggestion = $(this);
      getLocalisation($currentSuggestion);
      $('.js-localisation-recherche').removeClass('toggled');
      options.onItemsSelected(selectedItems);
    });

    $('.js-not-found-region').click(function() {
      selectedItems = availableItems.regions[0];
      options.onItemsSelected(selectedItems);
      $('.localisation-trigger').val(availableItems.regions[0].region.label);
    });
  }

  function initLocalisations(uniqueId) {
    if (!availableItems.hasSuggestions) {
      $('.js-city-section').hide();
      $('.js-department-section').hide();
      $('.js-region-section').hide();
      $('.js-localisations-displayer').hide();

      $fieldsetLocalisation.append(
        `<div class="row kit-ui">
          <div class="col-xs-12">
            <p class="not-found-paragraph">
              <span class="suggestion-not-found">${NOT_FOUND_TEXT}</span>
              <a class="links inline blue small js-not-found-region">
                ${availableItems.regions[0].region.label}
              </a>
            </p>
          </div>
        </div>`
      );
    }

    if (availableItems.cities.length > 0) {
      availableItems.cities.forEach(item => {
        $suggestedCities.append(
          `<span id="${uniqueId}-${item.postalCode}" class="suggestion-label js-suggestion-label">
            ${item.city}
          </span>`
        );
      });
    } else {
      $('.js-city-section').hide();
    }

    if (availableItems.departments.length > 0) {
      availableItems.departments.forEach(item => {
        $suggestedDepartments.append(
          `<span id="${uniqueId}-${item.department.code}" 
            class="suggestion-label js-suggestion-label">
            ${item.department.label} (${item.department.code})
          </span>`
        );
      });
    } else {
      $('.js-department-section').hide();
    }

    if (availableItems.hasSuggestions && availableItems.regions.length > 0) {
      availableItems.regions.forEach(item => {
        $suggestedRegions.append(
          `<span id="${uniqueId}-${item.region.code}" class="suggestion-label js-suggestion-label">
            ${item.region.label}
          </span>`
        );
      });
    } else {
      $('.js-region-section').hide();
    }

    const $suggestions = $('.js-suggestion-label');
    // S�lectionne le premier �l�ment par d�faut
    $suggestions.first().addClass('selected');
    // Retire la s�lection si on hover avec la souris
    $suggestions.mouseover(() => $suggestions.removeClass('selected'));
  }

  function getLocalisation(elem) {
    const elemTrimmed = elem
      .text()
      .trim()
      .split(' (')[0];
    $('.js-localisation-trigger').val('');

    if (elem.parent().hasClass('js-city-suggested-elements')) {
      $.each(availableItems.cities, function(i, city) {
        if (city.city === elemTrimmed && city !== selectedItems) {
          selectedItems = city;
          $('.js-localisation-trigger').val(elemTrimmed);
        }
      });
    } else if (elem.parent().hasClass('js-department-suggested-elements')) {
      $.each(availableItems.departments, function(i, department) {
        if (department.department.label === elemTrimmed && department !== selectedItems) {
          selectedItems = department;
          $('.js-localisation-trigger').val(`${elemTrimmed} (${department.department.code})`);
        }
      });
    } else if (elem.parent().hasClass('js-region-suggested-elements')) {
      $.each(availableItems.regions, function(i, region) {
        if (region.region.label === elemTrimmed && region !== selectedItems) {
          selectedItems = region;
          $('.js-localisation-trigger').val(elemTrimmed);
        }
      });
    } else {
      selectedItems = {};
    }
  }
}

// exposition sous forme de module jQuery
$.fn.extend({
  localisationSelector: function(customOptions) {
    return this.each(function() {
      localisationSelector($(this), customOptions);
    });
  }
});
export default localisationSelector;
